<template>
  <div class="addAddress absolute">
    <img :src="pageConfig.exchange_index_pic" alt="" style="width: 100%;" />
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">卡号</div>
        <input
          type="text"
          placeholder="请输入卡号"
          v-model="userCard.number"
          required
        />
      </div>

      <div class="item acea-row row-between-wrapper">
        <div class="name">密码</div>
        <input
          type="text"
          placeholder="请输入密码"
          v-model="userCard.password"
          required
        />
      </div>
    </div>

    <div class="keepBnt bg-color-red" @click="submit">兑换</div>
    <div
      class="keepBnt bg-color-red"
      style="margin: 0 auto 0 auto;"
      @click="$router.push('/user/cardBag')"
    >
      我的卡包
    </div>
    <div class="keepBnt bg-color-red" @click="myConversion">我的兑换</div>
    <div style="margin-top: 0.83rem; margin: 0.35rem">
      <div v-html="pageConfig.exchange_desc"></div>
    </div>
  </div>
</template>
<style>
.changeMsgImportant {
  color: #ff0000;
}

/* .changeMsgTime {
  font-size: 0.32rem;
} */

.specialMark {
  font-weight: bold;
}

/* .contactWay {
  margin-left: 0.7rem;
} */
</style>
<script type="text/babel">
import { postGoodsCard } from "@api/user";
import attrs, { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
export default {
  data() {
    return {
      show2: false,
      model2: "",
      id: 0,
      userCard: { is_default: 0 },
      address: {},
      a: false,
      pageConfig: {
        exchange_index_pic: "",
        exchange_desc: ""
      }
    };
  },
  mounted: function() {
    let id = this.$route.params.id;
    this.id = id;
    document.title = !id ? "兑换礼品卡" : "修改礼品卡";
    this.getPageConfig();
  },
  methods: {
    getPageConfig() {
      const pageConfig = JSON.parse(
        localStorage.getItem("goodsCardPageConfig")
      );
      this.pageConfig = pageConfig;
    },
    async submit() {
      let number = this.userCard.number,
        password = this.userCard.password;
      try {
        await this.$validator({
          number: [
            required(required.message("卡号")),
            attrs.range([1, 16], attrs.range.message("卡号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([1, 16], attrs.range.message("密码"))
          ]
        }).validate({ number, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      try {
        var that = this;
        var data = {
          id: that.id,
          number: number,
          password: password
        };
        postGoodsCard(data)
          .then(response => {
            console.log(response);

            if (response.data.is_optional_card > 0) {
              that.$router.replace({
                path: "/user/active_exchange_goods/",
                query: {
                  u: number,
                  p: password,
                  t: response.data.group_id
                }
              });
            } else {
              that.$router.replace({
                path: "/user/active_exchange_only_goods",
                query: {
                  u: number,
                  p: password,
                  t: response.data.group_id
                }
              });
            }
          })
          .catch(e => {
            that.$dialog.toast({ mes: e.msg });
          });
      } catch (e) {
        this.$dialog.toast({ mes: `兑换失败：${e.msg}` });
      }
    },

    myConversion() {
      this.$router.push("/user");
    }
  }
};
</script>
